<template>
  <div class="footer-container">
    <img
      class="footer-back"
      :src="require('../../assets/imgs/icon/footer-back.png')"
      @click="this.onBack"
    />
    <div class="footer-content-container">
      <div
        class="item-container"
        @click="onItemClick(ANSWER_RESULT_FOOTER_TYPE.LEVEL)"
      >
        <div :class="'item-top-text-inactive'">
          {{ selectLevel.difficultyTitle }}>
        </div>
        <div :class="'item-bottom-inactive'">当前难度</div>
      </div>

      <footer-item
        :active="active == ANSWER_RESULT_FOOTER_TYPE.WRONG_ANSWER"
        :text="'错题描述'"
        @click.native="onItemClick(ANSWER_RESULT_FOOTER_TYPE.WRONG_ANSWER)"
        :activeIcon="
          require('../../assets/imgs/icon/footer-wrong-answer-active.png')
        "
        :inactiveIcon="
          require('../../assets/imgs/icon/footer-wrong-answer-inactive.png')
        "
      ></footer-item>
      <footer-item
        :active="active == ANSWER_RESULT_FOOTER_TYPE.NEW_WORD"
        :text="'生词本'"
        @click.native="onItemClick(ANSWER_RESULT_FOOTER_TYPE.NEW_WORD)"
        :activeIcon="
          require('../../assets/imgs/icon/footer-new-word-active.png')
        "
        :inactiveIcon="
          require('../../assets/imgs/icon/footer-new-word-inactive.png')
        "
      ></footer-item>

      <div class="home-button" @click="this.onButtonClick">{{ this.text }}</div>
    </div>
  </div>
</template>

<script>
import { ANSWER_RESULT_FOOTER_TYPE } from "../../contants/article";
import FooterItem from "./FooterItem";
import { mapState } from "vuex";

export default {
  name: "ReadingFooter",
  data() {
    return {
      ANSWER_RESULT_FOOTER_TYPE: ANSWER_RESULT_FOOTER_TYPE,
    };
  },
  components: {
    FooterItem,
  },

  props: {
    text: {
      type: String,
      default: "",
    },
    active: {
      type: Number,
      default: 0,
    },

    // onBack: {
    //   type: Function,
    //   default: () => {},
    // },
    onItemClick: {
      type: Function,
      default: () => {},
    },
    onButtonClick: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    ...mapState({
      contentId: (state) => state.article.contentId,
      levels: (state) => state.article.levels,
    }),
    selectLevel() {
      let level = _.filter(
        this.$store.state.article.levels,
        (item) => item.contentId == this.contentId
      );

      return level[0] || {};
    },
  },
  methods: {
    onBack() {
      location.href = "/home";
    },
    // onButtonClick() {},
  },
};
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.footer-container {
  z-index: 5;
  position: fixed;
  bottom: 0;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
  height: 62px;
  width: 100%;
  background: #ffffff;
  display: flex;
  align-items: center;
}

.footer-back {
  width: 62px;
  height: 62px;
}

.footer-content-container {
  display: flex;
  flex: 1;
  align-items: center;
  margin-left: 5px;
  justify-content: space-between;
}

.item-container {
  text-align: center;
  margin: auto 5px;
}

.item-top-text {
  &-active {
    margin-top: 4px;
    font-size: 12px;
    line-height: 20px;
    font-weight: bold;
    color: #3994E7;
  }

  &-inactive {
    margin-top: 4px;
    font-size: 12px;
    line-height: 20px;
    font-weight: bold;
    color: #333333;
  }
}

.item-bottom {
  &-inactive {
    color: #999999;
    margin-top : 4px
    line-height: 16px;
    font-size: 9px;
  }

  &-active {
    color: #3994E7;
    margin-top : 4px
    line-height: 16px;
    font-size: 9px;
  }
}

.item-top-icon {
  height: 18px;
}

.home-button {
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  text-align: center;
  color: #ffffff;
  margin: 0 20px;
  // width: 100%;
  flex: 1;
  border-radius: 16px;
  background: linear-gradient(right, #98CEFF, #3994E7);
  background-color: orange;
}
</style>


// WEBPACK FOOTER //
// app/components/footer/AnswerResultFooter.vue